'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants.ts';
import { PrimedSupporterData, SupporterQueryPart } from '../queries.ts';
type SupporterDataStatus = PrimedSupporterData['dataStatus'];
export const getSupporterDataIssues = (dataStatus: SupporterDataStatus | undefined, keys?: SupporterQueryPart[]) => {
  if (!dataStatus?.isPartial || !dataStatus.issues?.length) {
    return [];
  }
  if (!keys?.length) {
    return dataStatus.issues;
  }
  return dataStatus.issues.filter(issue => keys.includes(issue.key as SupporterQueryPart));
};
export const hasSupporterDataIssues = (dataStatus: SupporterDataStatus | undefined, keys?: SupporterQueryPart[]) => {
  return getSupporterDataIssues(dataStatus, keys).length > 0;
};
export const useSupporterDataStatus = () => {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [QUERY_KEYS.supporterDataStatus];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = {
      queryKey: t0,
      queryFn: t2 => {
        const {
          queryKey
        } = t2;
        return queryClient.getQueryData(queryKey);
      },
      enabled: false
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};